<template>
  <el-breadcrumb class="tg-breadcrumb" separator=">">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="item.id">
        <span v-if="index == breadcrumbs.length - 1 || item.meta.disable">
          {{ parseTitle(item) }}
        </span>
        <a v-else @click.prevent="handleLink(item)">{{ parseTitle(item) }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  name: "TgBreadcrumb",
  data() {
    return {
      routeBeadcrumb: [],
    };
  },
  created() {
    this.parseBreadcrumbs();
  },
  computed: {
    storeBreadcrumbs() {
      return this.$store.state.breadcrumb.items;
    },
    breadcrumbs() {
      return [...this.routeBeadcrumb, ...this.storeBreadcrumbs];
    },
  },
  methods: {
    parseBreadcrumbs() {
      // filter routes with meta.title
      let matched = this.$route.matched.filter(
        (item) => item.meta && item.meta.title
      );

      let routeBeadcrumb = matched
        .filter(
          (item) =>
            item.meta && item.meta.title && item.meta.breadcrumb !== false
        )
        .map((item) => {
          if (!item.id) {
            item.id = item.name || item.path;
          }

          if (item.name == this.$route.name) {
            item.params = this.$route.params;
            item.query = this.$route.query;
          }

          if (item.redirect && item.redirect.name == this.$route.name) {
            item.redirect.params = this.$route.params;
            item.redirect.query = this.$route.query;
          }

          return item;
        });
        
      if (routeBeadcrumb[1] && routeBeadcrumb[1].redirect) {
        routeBeadcrumb[1].redirect = {
          ...routeBeadcrumb[1].redirect
        }
        routeBeadcrumb[1].redirect.params = {
          ...routeBeadcrumb[1].redirect.params,
          invoke: 'menu'
        }
      }
      this.routeBeadcrumb = routeBeadcrumb;
    },
    parseTitle(item) {
      if (!item.meta) {
        return;
      }

      let title = item.meta.title;

      if (typeof title === "string") {
        return item.meta.langKey ? this.$t(item.meta.langKey) : title;
      }

      if (typeof title === "function") {
        return title(item);
      }
      return title;
    },
    // pathCompile(path) {
    //     const { params } = this.$route
    //     var toPath = pathToRegexp.compile(path)
    //     return toPath(params)
    // },
    handleLink(item) {
      if (item.redirect) {
        this.$router.push(item.redirect);
        return;
      }
      this.$router.push(item).catch(() => {});
      this.$store.commit("breadcrumb/slice", item);
    },
  },
  watch: {
    $route(route, from) {
      this.$store.commit("breadcrumb/delete", from);

      let routeHasParent = !!route.meta.parent;
      let fromHasParent = !!from.meta.parent;
      let hasParent = routeHasParent && fromHasParent;

      if (from.matched.filter((x) => x.name === route.name).length == 0) {
        if (!hasParent || route.meta.parent.name != from.meta.parent.name) {
          this.$store.commit("breadcrumb/clear");
        }
      }

      if (route.path.startsWith("/redirect/")) {
        return;
      }
      this.parseBreadcrumbs();
    },
  },
};
</script>
